<div class="content-container content-with-sidebar h-screen">
    <header class="content-header">
        <div class="content-header-outer-wrap">
            <div class="content-header-inner-wrap">
                <div class="content-header-left-content">
                    <div class="flex-col">
                        <h1 class="content-header-title">Processing Queue</h1>
                        <div class="content-header-subtitle">Monitor data being processed asynchronous</div>
                    </div>
                </div>
                <div class="content-header-right-content">
                </div>
            </div>
        </div>
    </header>

    <main class="@container/workarea content-area content-area-padding">
        <div id="tab1" class="tabs-content tabs-content-active">
            <div class="flex flex-col gap-4">
                <div class="space-y-4 bg-white p-4">
                    <div class="overflow-x-auto mt-2 table-container">
                    <nav class="flex items-center flex-column flex-wrap md:flex-row justify-between py-4" aria-label="Table navigation">
                        <div>
                            <button (click)="loadItems()" title="Refresh log" class="cursor-pointer">
                                <i class="si-16 si-refresh" aria-hidden="true"></i>
                            </button>
                        </div>
                        <div class="flex">                            
                            <input type="text" [(ngModel)]="model.SearchText" (ngModelChange)="loadItems()" placeholder="Search by item id" class="rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400" />
                            <div>
                                <button type="button" (click)="toggleShowErrorsOnly()" title="Show errors only" class="pl-2 py-2 cursor-pointer" [ngClass]="{ 'opacity-20': !model.ShowErrorsOnly }">
                                    <i class="si-16 si-warning-sign" aria-hidden="true"></i>
                                </button>
                                <button type="button" (click)="toggleShowProducts()" title="Show products" class="pl-2 py-2 cursor-pointer" [ngClass]="{ 'opacity-20': !model.ShowProducts }">
                                    <i class="si-16 si-box" aria-hidden="true"></i>
                                </button>
                                <button type="button" (click)="toggleShowVariants()" title="Show variants" class="pl-2 py-2 cursor-pointer" [ngClass]="{ 'opacity-20': !model.ShowVariants }">
                                    <i class="si-16 si-barcode" aria-hidden="true"></i>
                                </button>
                                    <button type="button" (click)="toggleShowGlobalListValues()" title="Show global list values" class="pl-2 py-2 cursor-pointer" [ngClass]="{ 'opacity-20': !model.ShowGlobalListValues }">
                                    <i class=" si-16 si-bullet-list-67" aria-hidden="true"></i>
                                </button>
                            </div>
                        </div>
                        <div>
                            @if(totalFiltered > 0)
                            {
                                <span class="text-sm font-normal text-gray-500 dark:text-gray-400 mb-4 md:mb-0 block w-full md:inline md:w-auto">Showing <span class="font-semibold text-gray-900 dark:text-white">{{(((model.Page-1) * model.PageSize) + 1) + '-' + (model.Page * (totalFiltered < model.PageSize ? totalFiltered : model.PageSize))}}</span> of <span class="font-semibold text-gray-900 dark:text-white">{{totalFiltered}}</span></span>

                                <ul class="inline-flex -space-x-px rtl:space-x-reverse text-sm h-8">
                                    <li>
                                        <button class="flex items-center justify-center px-3 h-8 ms-0 leading-tight text-gray-500 bg-white border border-gray-300 hover:bg-gray-100 hover:text-gray-700" (click)="previousPage()">Previous</button>
                                    </li>
                                    <li>
                                        <button class="flex items-center justify-center px-3 h-8 leading-tight text-gray-500 bg-white border border-gray-300 hover:bg-gray-100 hover:text-gray-700" (click)="nextPage()">Next</button>
                                    </li>
                                </ul>
                            }
                        </div>
                    </nav>
                    <table class="table">
                        @if(totalFiltered > 0)
                        {
                        <thead>
                            <tr>
                                <th scope="col" class="table-header">
                                    Item id
                                </th>
                                <th scope="col" class="table-header">
                                    Entity type
                                </th>
                                <th scope="col" class="table-header">
                                    Change type
                                </th>
                                <th scope="col" class="table-header">
                                    Processing
                                </th>
                                <th scope="col" class="table-header">
                                    Created
                                </th>
                                <th scope="col" class="table-header">
                                    Last processed
                                </th>
                                <th scope="col" class="table-header">
                                    Status
                                </th>
                                <th scope="col" class="table-header">
                                    Info
                                </th>
                            </tr>
                        </thead>
                        }
                        @for (item of items; track item.Id) 
                        {
                            <tbody>
                                <tr class="bg-white border-b border-gray-200">
                                    <td class="table-cell font-medium text-gray-900 whitespace-nowrap">{{item.ExternalRef}}</td>
                                    <td class="table-cell">{{item.EntityType}}</td>
                                    <td class="table-cell">{{item.ItemType}}</td>
                                    <td class="table-cell">{{item.Processing}}</td>
                                    <td class="table-cell">{{item.CreatedTimestamp | date:"dd-MM-yyyy hh:mm:ss"}}</td>
                                    <td class="table-cell">{{item.CompletedTimestamp | date:"dd-MM-yyyy hh:mm:ss"}}</td>
                                    <td class="table-cell">
                                        @if(item.Status == 'Pending')
                                        {
                                        <span>Pending</span>
                                        }
                                        @if(item.Status == 'Processing')
                                        {
                                        <span class="text-blue-500">Processing</span>
                                        }
                                        @if(item.Status == 'Success')
                                        {
                                        <span class="text-green-500">Success</span>
                                        }
                                        @if(item.Status == 'Error')
                                        {
                                        <span class="text-red-500">Error</span>
                                        }
                                    </td>
                                    <td class="table-cell">
                                        <button (click)="currentItem = item" title="Show details" class="cursor-pointer">
                                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
                                                <path stroke-linecap="round" stroke-linejoin="round" d="M8.25 6.75h12M8.25 12h12m-12 5.25h12M3.75 6.75h.007v.008H3.75V6.75Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0ZM3.75 12h.007v.008H3.75V12Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm-.375 5.25h.007v.008H3.75v-.008Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Z" />
                                            </svg>
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        }
                        @if(totalFiltered == 0)
                        {
                        <tbody>
                            <tr>
                                <td colspan="8">
                                    <p class="text-center p-4">
                                        No rows
                                    </p>
                                </td>
                            </tr>
                        </tbody>
                        }
                    </table>
                    <nav class="flex items-center flex-column flex-wrap md:flex-row justify-between pt-4" aria-label="Table navigation">
                        <div>

                        </div>
                        @if(totalFiltered > 0)
                        {
                        <div>
                            <span class="text-sm font-normal text-gray-500 dark:text-gray-400 mb-4 md:mb-0 block w-full md:inline md:w-auto">Showing <span class="font-semibold text-gray-900 dark:text-white">{{(((model.Page-1) * model.PageSize) + 1)}} - {{(model.Page * (totalFiltered < model.PageSize ? totalFiltered : model.PageSize))}}</span> of <span class="font-semibold text-gray-900 dark:text-white">{{totalFiltered}}</span></span>
                            <ul class="inline-flex -space-x-px rtl:space-x-reverse text-sm h-8">
                                <li>
                                    <button type="button" class="flex items-center justify-center px-3 h-8 ms-0 leading-tight text-gray-500 bg-white border border-gray-300 hover:bg-gray-100 hover:text-gray-700" (click)="previousPage()">Previous</button>
                                </li>
                                <li>
                                    <button type="button" class="flex items-center justify-center px-3 h-8 leading-tight text-gray-500 bg-white border border-gray-300 hover:bg-gray-100 hover:text-gray-700" (click)="nextPage()">Next</button>
                                </li>
                            </ul>
                        </div>
                        }
                    </nav>
                </div>
                </div>
            </div>
        </div>
    </main>
</div>

@if(currentItem != null)
{
<div open id="drawer" aria-labelledby="drawer-title" class="fixed z-100 inset-0 size-auto max-h-none max-w-none overflow-hidden bg-transparent backdrop:bg-transparent">
    <div class="absolute inset-0 bg-gray-500/75 transition-opacity duration-500 ease-in-out data-closed:opacity-0"></div>

    <div tabindex="0" class="absolute inset-0 pl-10 focus:outline-none sm:pl-16">
        <div class="group/dialog-panel relative ml-auto block size-full max-w-lg transform transition duration-500 ease-in-out data-closed:translate-x-full sm:duration-700">
            <!-- Close button, show/hide based on slide-over state. -->
            <div class="absolute cursor-pointer top-0 left-0 -ml-8 flex pt-4 pr-2 duration-500 ease-in-out group-data-closed/dialog-panel:opacity-0 sm:-ml-10 sm:pr-4">
                <button (click)="currentItem = null" type="button" class="relative rounded-md text-gray-300 hover:text-white focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600">
                    <span class="absolute -inset-2.5"></span>
                    <span class="sr-only">Close panel</span>
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" data-slot="icon" aria-hidden="true" class="size-6">
                        <path d="M6 18 18 6M6 6l12 12" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                </button>
            </div>

            <div class="relative flex h-full flex-col overflow-y-auto bg-white py-6 shadow-xl">
                <div class="px-4 sm:px-6">
                    <h2 id="drawer-title" class="text-base font-semibold text-gray-900">Process queue details</h2>
                </div>
                <div class="relative mt-6 flex-1 px-4 sm:px-6">
                    <table class="table">
                        <tbody>
                            <tr>
                                <td class="table-cell align-top">ItemId</td>
                                <td class="table-cell">{{currentItem.ExternalRef}}</td>
                            </tr>
                            <tr>
                                <td class="table-cell align-top">Entity type</td>
                                <td class="table-cell">{{currentItem.EntityType}}</td>
                            </tr>
                            <tr>
                                <td class="table-cell align-top">Change type</td>
                                <td class="table-cell">{{currentItem.ItemType}}</td>
                            </tr>
                            <tr>
                                <td class="table-cell align-top">Created</td>
                                <td class="table-cell">{{currentItem.CreatedTimestamp | date:"dd-MM-yyyy hh:mm:ss"}}</td>
                            </tr>
                            <tr>
                                <td class="table-cell align-top">Last processed</td>
                                <td class="table-cell">{{currentItem.CompletedTimestamp | date:"dd-MM-yyyy hh:mm:ss"}}</td>
                            </tr>
                            <tr>
                                <td class="table-cell align-top">Status</td>
                                <td class="table-cell">{{currentItem.Status}}</td>
                            </tr>
                            <tr>
                                <td class="table-cell align-top">Error message</td>
                                <td class="table-cell">
                                    <code>{{currentItem.Errors}}</code>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</div>
}